import React from 'react';
import { IconButton, Tooltip, Box, Typography } from '@mui/material';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

const ListButton = ({ isInList, onClick, size = 'small', activeListName = null }) => {
  const getTooltipContent = () => {
    if (activeListName) {
      return (
        <Box>
          <Typography variant="caption" display="block" fontWeight="bold">
            Quick-Add aktiviert
          </Typography>
          <Typography variant="caption" display="block">
            Zu "{activeListName}" hinzufügen
          </Typography>
        </Box>
      );
    }
    return isInList ? 'In Listen' : 'Zu Listen hinzufügen';
  };

  return (
    <Tooltip title={getTooltipContent()}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        size={size}
        color={activeListName ? 'primary' : (isInList ? 'primary' : 'default')}
        sx={{
          backgroundColor: activeListName ? 'primary.lighter' : undefined,
          '&:hover': {
            backgroundColor: activeListName ? 'primary.light' : undefined,
          }
        }}
      >
        {activeListName ? <PlaylistAddCheckIcon /> : (isInList ? <PlaylistAddCheckIcon /> : <PlaylistAddIcon />)}
      </IconButton>
    </Tooltip>
  );
};

export default ListButton;
